import { render, staticRenderFns } from "./CompetitionDetailInfoLayout.vue?vue&type=template&id=909d67f0&scoped=true"
import script from "./CompetitionDetailInfoLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailInfoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909d67f0",
  null
  
)

export default component.exports